import React, { Component } from "react";

class ErrorFlightsBar extends Component {
	constructor() {
		super();
		this.alert = false;
		this.errorMap = new Map();
		this.createMap();
	}

	createMap() {
		this.errorMap.set(
			"AdultsValidationError",
			"Valor de adultos é inválido, deve ser um número inteiro positivo."
		);
		this.errorMap.set(
			"InfantsValidationError",
			"Valor de bebês é inválido, deve ser um número inteiro positivo."
		);
		this.errorMap.set(
			"InfantsCabinValidationError",
			"Existem regras específicas para a emissão de voos na classe executiva com bebê de colo. Refaça a sua pesquisa incluindo apenas os outros passageiros e se tiver interesse pela passagem ligue para: (31) 4020 2493."
		);
		this.errorMap.set(
			"ChildrenValidationError",
			"Valor de crianças é inválido, deve ser um número inteiro positivo."
		);
		this.errorMap.set(
			"AdultsGreaterInfantsValidationError",
			"O número máximo de bebês é de 1 para cada adulto."
		);
		this.errorMap.set(
			"FromValidationError",
			"Aeroporto de IDA é inválido, deve ser uma string de 3 caracteres, correspondente ao código IATA do aeroporto de origem."
		);
		this.errorMap.set(
			"ToValidationError",
			"Aeroporto de VOLTA é inválido, deve ser uma string de 3 caracteres, correspondente ao código IATA do aeroporto de destino."
		);
		this.errorMap.set("OutboundDateValidationError", "Data de IDA no formato inválido");
		this.errorMap.set("InvoundDateValidationError", "Data de VOLTA no formato inválido");
		this.errorMap.set("CabinValidationError", "Cabine é inválida, valores aceitos: EC ou EX.");
		this.errorMap.set(
			"TripTypeValidationError",
			"Tipo de viagem é inválida, valores aceitos: OW ou RT."
		);
		this.errorMap.set(
			"PastOutboundDateError",
			"Data de IDA está no passado. A data deve ser maior ou igual à data corrente."
		);
		this.errorMap.set(
			"PastInboundDateError",
			"Data de VOLTA está no passado. A data deve ser maior ou igual à data corrente."
		);
		this.errorMap.set("InboundBeforeOutboundError", "Data de VOLTA é antes da data de IDA");
		this.errorMap.set(
			"PassengersQuantityValidationError",
			"Quantidade de passageiros inválida, insira no máximo 9 passageiros"
		);
		this.errorMap.set(
			"UnknownParameterError",
			"Um ou mais parâmetros não são reconhecidos pela aplicação. Verifique os detalhes da sua busca."
		);
	}

	messageError(key) {
		return this.errorMap.get(key);
	}

	render() {
		return (
			<div className="alert alert-danger">
				<div className="alert--icon">
					<i className="icon-close" />
				</div>
				<div className="alert--message">
					<p>{this.messageError(this.props.typeError)}</p>
				</div>
			</div>
		);
	}
}

export default ErrorFlightsBar;
